import { render, staticRenderFns } from "./FactumAppealBookRspToLeaveGrantedPg.vue?vue&type=template&id=48f1f221&scoped=true"
import script from "./FactumAppealBookRspToLeaveGrantedPg.vue?vue&type=script&lang=ts"
export * from "./FactumAppealBookRspToLeaveGrantedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f1f221",
  null
  
)

export default component.exports